export default function LoanBenefits({
  badge,
  title,
  description,
  items = [],
}) {
  return (
    <section id="benefits" className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          {badge && (
            <span className="text-primary font-semibold uppercase tracking-wider">
              {badge}
            </span>
          )}

          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">
            {title}
          </h2>

          <p className="mt-6 text-lg text-slate-600 leading-8">{description}</p>
        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8 mt-16">
          {items.map((benefit) => {
            const Icon = benefit.icon;

            return (
              <div
                key={benefit.title}
                className="bg-white rounded-2xl border p-8 hover:-translate-y-1 transition-all"
              >
                <Icon className="h-10 w-10 text-primary" />

                <h3 className="mt-5 font-semibold text-xl">{benefit.title}</h3>

                <p className="mt-3 text-slate-600 leading-7">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
